import React, { useState } from 'react';
import products from './Data';
import './Product.css';

const Products = ({ addToCart }) => {
  const [clickedButtons, setClickedButtons] = useState([]);
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [showSuccessGif, setShowSuccessGif] = useState(false); 

  const handleMinPriceChange = (e) => {
    setMinPrice(e.target.value);
  };

  const handleMaxPriceChange = (e) => {
    setMaxPrice(e.target.value);
  };

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilter = () => {
  
    const filteredProducts = products.filter((product) => {
      const price = parseFloat(product.price);
      const min = parseFloat(minPrice);
      const max = parseFloat(maxPrice);
      if (!isNaN(min) && !isNaN(max)) {
        return price >= min && price <= max;
      } else if (!isNaN(min)) {
        return price >= min;
      } else if (!isNaN(max)) {
        return price <= max;
      }
      return true; 
    });

    // Filter products based on the search term
    const searchTermFilteredProducts = filteredProducts.filter((product) =>
      product.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredProducts(searchTermFilteredProducts);
  };

  const handleClick = (product) => {
    if (clickedButtons.includes(product.id)) {
      alert('This item is already in the cart!');
    } else {
      addToCart(product);
      setClickedButtons((prevClickedButtons) => [...prevClickedButtons, product.id]);
      setShowSuccessGif(true); 
      setTimeout(() => {
        setShowSuccessGif(false);
      }, 2000);
    }
  };

  const isButtonClicked = (productId) => {
    return clickedButtons.includes(productId);
  };

  return (
    <div className="container">
      <div className="row overflow-scrool">
        <div className="col-md-3 d-flex justify-content-end w-25">
          <div className="sidebar position-fixed d-flex flex-column p-3">
            <h3 style={{fontSize:"1.5rem"}}>Filters</h3>
            <div className="form-group">
              <label htmlFor="min-price">Min Price:</label>
              <input
                type="number"
                id="min-price"
                className="form-control"
                value={minPrice}
                onChange={handleMinPriceChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="max-price">Max Price:</label>
              <input
                type="number"
                id="max-price"
                className="form-control"
                value={maxPrice}
                onChange={handleMaxPriceChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="search">Search by Brand:</label>
              <input
                type="text"
                id="search"
                className="form-control"
                value={searchTerm}
                onChange={handleSearchTermChange}
              />
            </div>
            <button className="btn btn-primary" onClick={handleFilter} style={{fontSize:"0.9rem"}}>
              Apply Filters
            </button>
          </div>
        </div>
        <div className="col-md-9 w-75">
          <h2 className="text-center mt-3 mb-5  sticky-top overflow-scrool ">Products</h2>
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 w-100 d-flex ">
            {filteredProducts.map((product) => (
              <div key={product.id} className="col mb-4 d-flex justify-content-evenly">
                <div className="card h-100">
                  <div className="card-img-container h-50">
                    <img src={product.img} alt={product.title} className="card-img-top img-fluid" />
                  </div>
                  <div className="card-body d-flex flex-column justify-content-around">
                    <h5 className="card-title">{product.title}</h5>
                    <p className="card-text">{product.desc}</p>
                    <p className="card-text text-dark h5">
                      Price: <span style={{ color: '#eb188c', fontWeight: 'bold' }}>Rs {product.price}</span>
                    </p>
                    <button
                      onClick={() => handleClick(product)}
                      className={`btn ${isButtonClicked(product.id) ? 'btn-success' : 'btn-primary'}`}
                    >
                      {isButtonClicked(product.id) ? 'Added to Cart' : 'Add to Cart'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {showSuccessGif && (
        <div className="success-gif-container">
          <img src={'/images/addtocart.gif'} alt="Success" className="success-gif" />
        </div>
      )}
    </div>
  );
};

export default Products;
